import 'css-chunksrc/client/scenes/projectPopup/tagList/tag/styles.scss';export default {
  "tag": "_tag_14fv7_1",
  "icon": "_icon_14fv7_26",
  "removeTagIconContainer": "_removeTagIconContainer_14fv7_38"
};